import { render, staticRenderFns } from "./AcmNotificationPage.vue?vue&type=template&id=08038ea2&scoped=true&"
import script from "./AcmNotificationPage.vue?vue&type=script&lang=js&"
export * from "./AcmNotificationPage.vue?vue&type=script&lang=js&"
import style0 from "./AcmNotificationPage.vue?vue&type=style&index=0&id=08038ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08038ea2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSimpleTable})
